import { _ } from 'wgnet-awesomejs';
import $ from 'jquery';

import BaseInput from 'source/lib/component/input/base';
import messages from 'messages';

import template from './template.html';

const CaptchaInput = BaseInput.extend({
    name: 'captcha-input',
    template,
    initialize(options) {
        const parsedOptions = options;
        try {
            parsedOptions['pow-allowed'] = JSON.parse(parsedOptions['pow-allowed']);
        } catch (e) {
            parsedOptions['pow-allowed'] = false;
        }
        BaseInput.prototype.initialize.call(this, parsedOptions);
        this.forcedMessage = this.data['pow-allowed'];
        this.$el.hide();
        this.bindElements();
        this.bindParent();
    },
    events: {
        'click .js-captcha-reload': 'reload',
        'change .js-captcha-input': 'change',
        'keyup .js-captcha-input': 'onClearErrors'
    },
    bindElements() {
        this.$image = this.$('.js-captcha-image');
        this.$input = this.$('.js-captcha-input');
        this.$error = this.$('.js-form-field-error-content');
    },
    bindParent(...args) {
        BaseInput.prototype.bindParent.apply(this, args);
        this.$root = $('#js-view');
        this.$root.on('component:all:captcha:show',
            _.bind(this.updateChallenge, this));
        this.$root.on('component:all:captcha:hide',
            _.bind(this.hide, this));
    },
    onParentError(event, origin) {
        const errors = _.extract(origin, 'responseJSON.errors.captcha');

        if (errors) {
            const key = errors[0] || 'required';
            const msg = _.extract(messages, `errors.captcha.${key}`) ||
                  _.extract(messages, 'errors.captcha.default', '');
            this.$error.html(msg);
            this.$error.removeClass('hidden');
            if (this.forcedMessage) {
                this.addErrorMessageClass();
            }
        } else {
            this.onClearErrors();
        }
    },
    onClearErrors() {
        this.$error.addClass('hidden');
        this.$error.html('');
        if (this.forcedMessage) {
            this.removeErrorMessageClass();
        }
    },
    onErrorUpdate() {
        this.value = undefined;
    },
    updateChallenge(event, data) {
        this.$el.show();
        this.$image.attr('src', data.url);
        this.$input.val('');
    },
    addErrorMessageClass() {
        this.$el.children('fieldset').addClass(this.data['error-class']);
    },
    removeErrorMessageClass() {
        this.$el.children('fieldset').removeClass(this.data['error-class']);
    },
    hide() {
        this.$el.hide();
        this.$image.removeAttr('src');
    },
    reload(event) {
        this.components.proxyEvent('reload', event, this);
        return false;
    }
});

export default CaptchaInput;



// WEBPACK FOOTER //
// ./static-source/js/lib/component/input/captcha/index.js